import React from 'react';
import { Box, Typography } from '@mui/material';

import { signalBand } from './RisksSection';

// Per-pillar score cards, rendered above the streamed risk-summary insight to
// mirror the Risks tab: band-colored left accent + tinted bg, pillar name, and
// the score to 3 dp. risk_meta.scores arrives on the SIGNAL scale ([-1, 1],
// higher is better) — the same payload the Risks tab converts with
// toRiskScores before charting — so these are banded with signalBand, not
// riskBand, which would read a negative (bad) score as low risk.
// Shared by the single-report Ask Prompta chat and the compare-report chat,
// which renders one set per compared report.
const RiskScoreCards = ({ scores }) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
            gap: '10px',
            mb: 1.5,
        }}
    >
        {Object.entries(scores).map(([pillar, val]) => {
            const band = signalBand(val);
            const name = pillar.charAt(0).toUpperCase() + pillar.slice(1).toLowerCase();
            return (
                <Box
                    key={pillar}
                    title={`${name} — ${band.label}`}
                    sx={{
                        bgcolor: band.bg,
                        borderLeft: `3px solid ${band.color}`,
                        borderRadius: '0 8px 8px 0',
                        px: 1.25,
                        py: 1,
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.2, mb: 0.25 }}
                    >
                        {name}
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: band.color,
                            lineHeight: 1.2,
                            fontVariantNumeric: 'tabular-nums',
                        }}
                    >
                        {Number(val).toFixed(3)}
                    </Typography>
                </Box>
            );
        })}
    </Box>
);

export default RiskScoreCards;
